import {
    INotificationItem,
} from '../interfaces/notification-message.interface';
import { ISO8601 } from '@alk/dates';
import {
    DATA_01 as MESSAGE_01,
    DATA_02 as MESSAGE_02,
} from './formatted-text.data';
import { WithClient } from '../interfaces';

export type INotificationsForClient = WithClient<INotificationItem>;

export const DATA_01: INotificationsForClient = {
    id: 'DATA_01',
    relatedOrderId: 'DATA_01',
    type: 'sent',
    dateCreated: '2020-08-06T14:04:22Z' as ISO8601,
    title: 'title 1',
    message: MESSAGE_01,
    haveBeenSeen: false,
    newMarkVisible: true,
    clientId: 1,
    loaded: true,
};

export const DATA_02: INotificationsForClient = {
    id: 'DATA_02',
    type: 'filled',
    dateCreated: '2020-09-24T15:14:42Z' as ISO8601,
    title: 'title 2',
    message: MESSAGE_02,
    haveBeenSeen: false,
    newMarkVisible: true,
    clientId: 2,
    loaded: true,
};

export const DATA_03: INotificationsForClient = {
    id: 'DATA_03',
    type: 'rejected',
    dateCreated: '2020-08-06T16:37:02Z' as ISO8601,
    title: 'Order Rejected',
    message: MESSAGE_01,
    haveBeenSeen: false,
    newMarkVisible: true,
    clientId: 2,
    loaded: true,
};

export const DATA_04: INotificationsForClient = {
    id: 'DATA_04',
    type: 'suspended',
    dateCreated: '2020-08-06T16:45:38Z' as ISO8601,
    title: 'title 4',
    message: MESSAGE_01,
    haveBeenSeen: false,
    newMarkVisible: true,
    clientId: 2,
    loaded: true,
};

export const DATA_05: INotificationsForClient = {
    id: 'DATA_05',
    relatedOrderId: 'DATA_05',
    type: 'cancelled',
    dateCreated: '2020-08-06T16:45:38Z' as ISO8601,
    title: 'Cancelled',
    message: MESSAGE_01,
    haveBeenSeen: false,
    newMarkVisible: true,
    clientId: 2,
    loaded: true,
};

export const DATA_06: INotificationsForClient = {
    id: 'DATA_06',
    relatedOrderId: 'DATA_06',
    type: 'orderChanged',
    dateCreated: '2020-08-06T16:45:38Z' as ISO8601,
    title: 'Amended',
    message: MESSAGE_01,
    haveBeenSeen: false,
    newMarkVisible: true,
    clientId: 2,
    loaded: true,
};

export const ARRAY_OF_NOTIFICATIONS_01 = [
    DATA_01,
    DATA_02,
    DATA_03,
    DATA_04,
    DATA_05,
    DATA_06,
];
